import React from 'react';

const StartScreen = ({ onStart }) => {
  return (
    <div className="text-center p-6">
      <h1 className="text-3xl font-bold text-purple-700 mb-4">🎈 لعبة من أنا؟ 🎈</h1>
      <p className="text-lg text-gray-700 mb-6">
        لعبة ممتعة للأطفال لاختبار ذكائهم بالحروف!
      </p>
      <button
        onClick={onStart}
        className="bg-yellow-400 hover:bg-yellow-500 text-black px-6 py-3 rounded-full text-xl"
      >
        ابدأ اللعب 🎮
      </button>
    </div>
  );
};

export default StartScreen;
